import tw, { TwStyle } from 'twin.macro';

const LineLoaderWrapper = tw.div`w-full h-[2px] relative overflow-x-hidden`;
const LineLoaderBar = tw.div`w-0 h-full absolute bg-accent-2 animate-line-loader ease-[cubic-bezier(.31,.22,.24,1)]`;

export const LineLoader = ({
  loading,
  loaderStyles,
  ...rest
}: {
  loading: boolean;
  loaderStyles?: TwStyle;
}) => {
  if (!loading) {
    return <LineLoaderWrapper {...rest} />;
  }

  return (
    <LineLoaderWrapper {...rest}>
      <LineLoaderBar css={loaderStyles} />
    </LineLoaderWrapper>
  );
};
